










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IAccordion from './types';

@Component
export default class Accordion extends Vue implements IAccordion {
  @Prop({ type: Boolean, default: false })
  readonly opened!: boolean;

  @Prop({ type: String, default: '' })
  readonly height!: string;

  @Prop({ type: String, default: '0' })
  readonly initHeight!: string;

  $refs!: {
    wrapper: HTMLElement;
  };

  public accordionHeight: string = this.initHeight;

  @Watch('opened', { immediate: true })
  async onToggle(): Promise<void> {
    await this.$nextTick();
    const { height, $refs, initHeight } = this;
    const result = height || `${$refs.wrapper.scrollHeight}px`;
    this.accordionHeight = this.opened ? result : initHeight;
  }

  @Watch('height')
  onChangeHeight(height: string): void {
    this.accordionHeight = height;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/accordion/Accordion.vue